// Initial = first upload for a shipment; Add appends to what's there; Replace
// swaps the whole set.
export const CustomsDocsUploadMode = {
  Initial: "Initial",
  Add: "Add",
  Replace: "Replace",
} as const;
export type CustomsDocsUploadMode =
  (typeof CustomsDocsUploadMode)[keyof typeof CustomsDocsUploadMode];
